import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
    LOGOUT_LOADING,
    LOGOUT_SUCCESS,
    LOGOUT_FAILED,
  } from "../Constants/logoutConstants";

export const getLogout = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    dispatch({ type: LOGOUT_LOADING });

    const requestData = {
      token: userLocalData.id,
    };
    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;
    const { data } = await axios.post(FOLDERPATH + "/GenericApi/logout",
    requestData,
    {
      headers,
    }
    );

    dispatch({
      type: LOGOUT_SUCCESS,
      payload: data,
    });

//if(data.status=="success"){
  localStorage.clear();
//}

  } catch (error) {
    dispatch({
      type: LOGOUT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
};